(function($){

	/* Before After Template */

	$(document).ready(function () {
	    $('.tabs a').click(function () {
	        $('.panel').hide();
	        $('.tabs a').parent('li').attr('aria-selected', false);
	        $('.tabs a.active').removeClass('active');
	        $(this).addClass('active').parent('li').attr('aria-selected', true);
	        $('.panelContainer .panel').attr('aria-hidden', true);
	        var panel = $(this).attr('href');
	        $(panel).fadeIn(1000).attr('aria-hidden', false);
	        return false;
	    });

	    $('.tabs li:first a').click();

	    function showIngredient(text) {
	        let letter = text.charAt(text.length - 1);
	        $(`.cards-block .cards-block-inner`).hide();
	        $(`.cards-block .cards-block-inner:nth-child(${letter})`).show();
	                          
			$(`.more-result-inner .before_after_img_slider`).hide();
	        $(`.more-result-inner .before_after_img_slider:nth-child(${letter})`).show();
	    }

	    let text = $('.tabs-row ul li a.active').attr('href');
	    showIngredient(text);

	    $('.tabs-row ul li a').on('click', function () {
	        let href = $(this).attr('href');
	        showIngredient(href);
	    });

	    $('.more-result-inner .before_after_img_slider:nth-child(1), .more-result-inner .before_after_img_slider:nth-child(2), .more-result-inner .before_after_img_slider:nth-child(3), .more-result-inner .before_after_img_slider:nth-child(4), .more-result-inner .before_after_img_slider:nth-child(5), .more-result-inner .before_after_img_slider:nth-child(6)').slick({
		        infinite: true,
		        slidesToShow: 3,
		        autoplay: true,
		        slidesToScroll: 3,
		        arrows: true,
		        dots: true,
		        responsive: [
		            {
		                breakpoint: 1024,
		                settings: {
		                    slidesToShow: 2,
		                }
		            },
		            {
		                breakpoint: 767,
		                settings: {
		                    slidesToShow: 1,
		                }
		            }
		            // You can unslick at a given breakpoint now by adding:
		            // settings: "unslick"
		            // instead of a settings object
		        ]
	    	});

	});

	$("#resizable_1, #resizable_2, #resizable_3, #resizable_4, #resizable_5, #resizable_6, #resizable_7, #resizable_8, #resizable_9").resizable(
        {
            handles: 'e',
            resize: function (e, ui) {
                console.log('resized!');
            }
        }
    );

})(jQuery);